import { Menu, LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/hooks/use-auth";
import { EnvironmentPill } from "@/components/layout/environment-banner";

interface HeaderProps {
  onMenuToggle: () => void;
}

export function Header({ onMenuToggle }: HeaderProps) {
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-[var(--env-banner-h)] z-40 flex h-16 items-center gap-4 border-b border-[hsl(var(--sidebar-border))] bg-[hsl(var(--primary))] px-4 text-[hsl(var(--primary-foreground))] lg:px-6">
      <Button
        variant="ghost"
        size="icon"
        className="shrink-0 text-[hsl(var(--primary-foreground))] hover:bg-[hsl(var(--sidebar-accent))] lg:hidden"
        onClick={onMenuToggle}
      >
        <Menu className="h-5 w-5" />
        <span className="sr-only">Toggle navigation menu</span>
      </Button>

      <div className="flex min-w-0 flex-1 items-center gap-3">
        <h2 className="truncate font-heading text-lg font-semibold tracking-tight">
          ITS Performance Intelligence
        </h2>
        <EnvironmentPill />
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="text-[hsl(var(--primary-foreground))] hover:bg-[hsl(var(--sidebar-accent))]"
          >
            <User className="h-5 w-5" />
            <span className="sr-only">User menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium leading-none">{user?.name}</p>
              <p className="text-xs leading-none text-[hsl(var(--muted-foreground))]">
                {user?.email}
              </p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => void logout()}>
            <LogOut className="mr-2 h-4 w-4" />
            <span>Log out</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
